import React, { useEffect } from 'react';

import {
  BottomDrawer,
  IBottomDrawerProps,
} from '@rbilabs/components-library/build/components/bottom-drawer';

import { useCdpContext } from 'state/cdp';
import { CustomEventNames, EventTypes } from 'state/cdp/constants';

interface ActionsheetProps extends IBottomDrawerProps {
  onOpenEventMessage: string;
}

export const ActionsheetWrapper = ({ onOpenEventMessage, ...props }: ActionsheetProps) => {
  const { trackEvent } = useCdpContext();

  useEffect(() => {
    if (props.dialogState.visible) {
      trackEvent({
        name: CustomEventNames.ACTION_SHEET_VIEW,
        type: EventTypes.Other,
        attributes: {
          actionSheetHeader: onOpenEventMessage,
        },
      });
    }
  }, [props.dialogState.visible, trackEvent, onOpenEventMessage]);

  return <BottomDrawer {...props} />;
};
